import { LayoutComponent } from "@jelly/lesson";
import config from "appConfig";

const components: LayoutComponent[] = [
  {
    variant: "layout",
    data: {
      type: "table",
      options: {
        cols: 2,
        rows: 3,
        rowsSize: [4, 0.5, 1],
        colSpan: {
          "2:0": 2,
        },
        components: [
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/02/14/principle/outer-middle-chart-1.svg`,
                  },
                },
                styles: {
                  padding: "2%",
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/02/14/principle/outer-middle-chart-2.svg`,
                  },
                },
                styles: {
                  padding: "2%",
                },
              },
            },
          ],
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "text",
                  options: {
                    data: "Outer and middle ear filter",
                    scrollbars: false,
                    styles: {
                      fontWeight: 700,
                    },
                  },
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "text",
                  options: {
                    data: "Signal after being filtered",
                    scrollbars: false,
                    styles: {
                      fontWeight: 700,
                    },
                  },
                },
              },
            },
          ],
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "hint",
                  options: {
                    data:
                      "The first processing that takes place to a sound entering our ear is filtering by the anatomy of our outer and middle ear. Figures below demonstrate the filter used in the hearing model for this purpose and also the filtered signal",
                    direction: "row",
                  },
                },
                styles: {
                  width: "615px",
                },
              },
            },
          ],
        ],
      },
    },
  },
];

export default components;
